import Loadable from '../../components/Loadable';
import { lazy } from 'react';
import { authRoles } from '../../auth/authRoles';

const Sitemap = Loadable(lazy(() => import('./sitemap')));

const sitemapRoutes = [
  { path: '/dashboard/sitemap', element: <Sitemap />, auth: authRoles.admin },
];

export default sitemapRoutes;
